import * as types from "../types_user";
import axios from "axios/index";
import authHeader from "../../authHeader";

const state = {
  users: {
    isLoading: false,
    isError: false,
    data: [],
    filter: {},
    librarians: [],
  },
};

const getters = {
  isError: (state) => {
    return state.users.isError;
  },
  isLoading: (state) => {
    return state.users.isLoading;
  },
  data: (state) => {
    return state.users.data;
  },
  filter: (state) => {
    return state.users.filter;
  },
  librarians: (state) => {
    return state.users.librarians;
  },
};

const mutations = {
  [types.USR_MUTATION_CLEAR_FILTER]: (state, payload) => {
    state.users.filter = {};
  },
};

const actions = {
  [types.USR_ACTION_CLEAR_FILTER]: ({ commit }, payload) => {
    commit(types.USR_MUTATION_CLEAR_FILTER, payload);
  },

  setFilter: (context, payload) => {
    context.state.users.filter = payload;
    context.state.users.isLoading = true;
    context.state.users.data = [{}];
  },

  [types.USR_ACTION_REFRESH]: (context) => {
    context.state.users.isLoading = true;
  },
  add_assoc: (context, payload) => {
    // context.state.users.isLoading = true;
    return new Promise((resolve, reject) => {
      // console.log("Add Association: ", payload);
      return axios({
        method: "POST",
        url: "/user/update/partyIds/add",
        data: payload,
        headers: authHeader(),
      })
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  remove_assoc: (context, payload) => {
    // context.state.users.isLoading = true;
    return new Promise((resolve, reject) => {
      // let inpStr = payload.username + "_" + payload.partyId;
      // console.log("Remove Association: ", payload);
      return axios({
        method: "POST",
        url: "/user/update/partyIds/remove",
        data: payload,
        headers: authHeader(),
      })
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  [types.USR_ACTION_DELETE]: (context, payload) => {
    return new Promise((resolve, reject) => {
      // console.log("Delete user: ", payload);
      return axios({
        method: "DELETE",
        url: "/user/delete",
        data: payload.username,
        headers: authHeader(),
      })
        .then((res) => {
          resolve(res);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getLibrarians: (context) => {
    return new Promise((resolve, reject) => {
      return axios({
        method: "GET",
        url: "/user/all",
        headers: authHeader(),
      })
        .then((res) => {
          // console.log(res.data);
          let librarians = res.data.filter((user) => {
            return user.role === "Librarian";
          });
          context.state.users.librarians = librarians;
          resolve(librarians);
        })
        .catch((error) => {
          reject(JSON.stringify(error));
        });
    });
  },
  getAll: (context) => {
    context.state.users.isLoading = true;
    return new Promise((resolve, reject) => {
      return axios({
        method: "GET",
        url: "/user/all",
        headers: authHeader(),
      })
        .then((res) => {
          context.state.users.isLoading = true;
          resolve(res.data);
        })
        .catch((error) => {
          context.state.users.isLoading = false;
          context.state.users.isError = true;
          reject(JSON.stringify(error));
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/users.js